import {
  Box,
  Table,
  Thead,
  Tbody,
  Th,
  Tr,
  Td,
  Flex,
  IconButton,
  Link as ChakraLink,
  Image,
  useToast,
} from "@chakra-ui/react";
import {
  LanguageOptions,
  SortOrder,
  useCategoriesQuery,
  useDeleteCategoryMutation,
} from "../../generated/graphql";
import { FcRefresh, FcPlus, FcEditImage } from "react-icons/fc";
import DeleteItem from "../../components/delete/DeleteItem";
import Loading from "../../components/loading/Loading";
import Error from "../../components/error/Error";
import PageLayout from "../../components/ui/PageLayout";
import { Link } from "react-router-dom";
import { IoMdReorder } from "react-icons/io";
import Description from "../../components/description/Description";
// import CategoryDiscountModal from "../../components/CategoryDiscountModal";

interface Props {
  parentId?: string;
}

const All: React.VFC<Props> = ({ parentId }) => {
  const [deleteCategory, { loading: deleteLoading }] = useDeleteCategoryMutation();
  const toast = useToast();
  const { loading, error, data, refetch } = useCategoriesQuery({
    variables: {
      orderBy: {
        order: SortOrder.asc,
      },
      where: {
        ...(parentId
          ? { parentCategoryId: { equals: parentId } }
          : { parentCategoryId: { equals: null } }),
      },
    },
    fetchPolicy: "network-only",
  });
  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Error />;
  }

  const handleDelete = async (id: string) => {
    try {
      await deleteCategory({
        variables: {
          where: {
            id,
          },
        },
      });

      return toast({
        duration: 1500,
        title: "Başarılı",
        status: "success",
        description: "Silme işlemi tamamlandı",
        onCloseComplete: async () => {
          return refetch();
        },
      });
    } catch (error: any) {
      return toast({
        duration: 1500,
        title: "Hata",
        status: "error",
        description: error.message || "Bir hata oluştu",
      });
    }
  };
  return (
    <PageLayout>
      <Flex
        mb={6}
        justifyContent={"space-between"}
        alignItems="center"
        bgColor={"gray.100"}
        padding={2}
        rounded="md"
      >
        <Box fontSize={"18px"} fontWeight="bold">
          Kategoriler
        </Box>
        <Flex experimental_spaceX={4}>
          <IconButton
            to={`/category/order/${parentId ? parentId : ""}`}
            as={Link}
            icon={<IoMdReorder fontSize="24px" />}
            aria-label="Order"
            onClick={() => refetch()}
          />
          <IconButton
            icon={<FcRefresh />}
            aria-label="Refetch Query"
            onClick={() => refetch()}
          />
          <IconButton
            to={`/category/create`}
            as={Link}
            icon={<FcPlus />}
            aria-label="Add Item"
            onClick={() => refetch()}
          />
        </Flex>
      </Flex>
      <Table>
        <Thead>
          <Tr>
            <Th>#</Th>
            <Th>Görsel</Th>
            <Th>Başlık</Th>
            <Th>Marka</Th>
            <Th textAlign="center">Alt kategori</Th>
            <Th textAlign="center">İşlem</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data?.categories.map((category, i) => {
            return (
              <Tr key={i}>
                <Td>{i + 1}</Td>
                <Td w="10%">
                  <Image
                    maxW="80px"
                    src={
                      category.photos[0]
                        ? `${process.env.REACT_APP_CDN}/${category.photos[0]}`
                        : "/noimg.png"
                    }
                    alt="Category"
                  />
                </Td>
                <Td>
                  <Description
                    field="category"
                    id={category.id}
                    descriptions={category.descriptions}
                    refetch={refetch}
                  />
                </Td>
                <Td>{category.brand}</Td>
                <Td textAlign="center">
                  <ChakraLink as={Link} to={`/category/${category.id}`}>
                    {category._count?.subCategories}
                  </ChakraLink>
                </Td>

                <Td>
                  <Flex justifyContent={"center"}>
                    {/* <Box mx={2}>
                      <CategoryDiscountModal
                        categoryId={category.id}
                        discountAmount={category.discountAmount}
                        name={
                          category.descriptions.find(
                            (l) => l.language === LanguageOptions.TR
                          )?.title || ""
                        }
                        refetch={refetch}
                      />
                    </Box> */}
                    <Box mx={2}>
                      <IconButton
                        aria-label="Edit"
                        icon={<FcEditImage />}
                        as={Link}
                        to={`/category/update/${category.id}`}
                      />
                    </Box>
                    <Box mx={2}>
                      <DeleteItem
                        id={category.id}
                        loading={deleteLoading}
                        title={`${
                          category.descriptions.find(
                            (d) => d.language === LanguageOptions.TR
                          )?.title
                        }`}
                        handleDelete={handleDelete}
                      />
                    </Box>
                  </Flex>
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </PageLayout>
  );
};

export default All;
